import { useCallback } from "react";
import { StringMap, TOptions } from "i18next";
import { useTranslation } from "react-i18next";

export const useModifiedTranslation = () => {
  const { i18n, t } = useTranslation();
  const defaultLocaleForNumbers = "fi-FI";
  const defaultBasicDateFormatLocale = "fi-FI";
  // for all languages currencies are displayed as ISO code at the end of value - business decision
  const modifiedT = useCallback(
    (key: string, options?: TOptions<StringMap>) => {
      if (key === "number") {
        return `${t("number", {
          ...options,
          locale: defaultLocaleForNumbers,
          maximumFractionDigits: 8,
        })}`;
      }

      if (key === "numberWithPercent") {
        return `${
          t("number", {
            ...options,
            locale: defaultLocaleForNumbers,
            maximumFractionDigits: 2,
          }) + "%"
        }`;
      }

      if (key === "numberWithCurrency") {
        if (options?.currency) {
          const { currency, ...optionsWOCurrency } = options;
          return `${t("number", {
            ...optionsWOCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            locale: defaultLocaleForNumbers,
          })}\xa0${currency}`;
        }
      }

      if (key === "numberWithCurrencyRounded") {
        if (options?.currency) {
          const { currency, ...optionsWOCurrency } = options;
          return `${t("numberRounded", {
            ...optionsWOCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            locale: defaultLocaleForNumbers,
          })}\xa0${currency}`;
        }
      }
      if (key === "date") {
        return `${t("date", {
          ...options,
          locale: defaultBasicDateFormatLocale,
        })}`;
      }

      return t(key, { ...options, defaultLocaleForNumbers });
    },
    [t, defaultLocaleForNumbers]
  );

  return { i18n, t: modifiedT };
};
